import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ProjectsComponent } from './projects/projects.component';
import { MinesweeperComponent } from './minesweeper/minesweeper.component';
import { ContactComponent } from './contact/contact.component';
import { ScoreboardComponent } from './scoreboard/scoreboard.component';
import { WindowComponent } from './window/window.component';
import { PermanentAddressComponent } from './permanent-address/permanent-address.component';
import { PostmodernSlimeComponent } from './postmodern-slime/postmodern-slime.component';
import { ProjectGalleryComponent } from './project-gallery/project-gallery.component';
import { NapkinDrawingsComponent } from './napkin-drawings/napkin-drawings.component';
import { BeingHaterComponent } from './being-hater/being-hater.component';
import { MetaphysicalComponent } from './metaphysical/metaphysical.component';
import { BananasComponent } from './bananas/bananas.component';
import { ThePitchComponent } from './the-pitch/the-pitch.component';
import { HowToComponent } from './how-to/how-to.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { ImageThumbnailComponent } from './image-thumbnail/image-thumbnail.component';
import { EmbeddedVideoComponent } from './embedded-video/embedded-video.component';
import { EmbeddedPodcastComponent } from './embedded-podcast/embedded-podcast.component';
import { WalkTalkComponent } from './walk-talk/walk-talk.component';
import { FiveMinuteCraftsComponent } from './five-minute-crafts/five-minute-crafts.component';
import { TalkShowComponent } from './talk-show/talk-show.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ProjectsComponent,
    MinesweeperComponent,
    ContactComponent,
    ScoreboardComponent,
    WindowComponent,
    PermanentAddressComponent,
    PostmodernSlimeComponent,
    ProjectGalleryComponent,
    NapkinDrawingsComponent,
    BeingHaterComponent,
    MetaphysicalComponent,
    BananasComponent,
    ThePitchComponent,
    HowToComponent,
    VideoPlayerComponent,
    ImageThumbnailComponent,
    EmbeddedVideoComponent,
    EmbeddedPodcastComponent,
    WalkTalkComponent,
    FiveMinuteCraftsComponent,
    TalkShowComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
